module.exports = __webpack_public_path__ + "img/block-375.0733cc50.jpg";